import { AUDIO_FORMAT } from '@/constants/api/api';

/**
 * AudioContext の生成オプション
 *
 * 引数なしで AudioContext を生成すると、サンプリングレートが既定の出力デバイスに
 * 依存して変動する(Bluetooth ヘッドセットが通話プロファイルに入ると 16kHz、
 * 仮想デバイスでは 44.1kHz になるなど)。エンジンへの申告は AUDIO_FORMAT 固定のため、
 * レートを明示しないと実際のレートと申告が食い違う(Issue #1835)。
 */
export const AUDIO_CONTEXT_OPTIONS: AudioContextOptions = {
  sampleRate: AUDIO_FORMAT.sampleRate,
};

/**
 * AudioWorklet モジュールのパス
 *
 * public/audioProcessor.js はハッシュを含まない固定 URL の静的アセットのため、
 * デプロイ後も HTTP キャッシュが古い内容を返し得る。JS バンドルはハッシュ付きで
 * 配信されるので「新しいフック x 古い worklet」の組み合わせが成立してしまい、
 * その場合は送信音声が壊れる。
 *
 * バージョンはビルド時に craco.config.js がファイル内容のハッシュから埋め込む
 * (jest/storybook など webpack を通らない環境では 'dev')。
 * ※Service Worker 側でも同一オリジンは NetworkOnly にしているが
 *   (src/service-worker.ts)、CDN/ブラウザの HTTP キャッシュは別レイヤなので
 *   こちらのクエリで防ぐ。
 */
export const AUDIO_PROCESSOR_MODULE_URL = `/audioProcessor.js?v=${
  process.env.REACT_APP_AUDIO_PROCESSOR_HASH || 'dev'
}`;

/**
 * マイク利用時の設定
 */
export const USER_MEDIA_CONSTRAINTS = {
  // チャンネル数の初期値
  DEFAULT_CHANNELS: AUDIO_FORMAT.channels,
} as const;
